'use strict';

import React from 'react';
import Modal from 'react-modal';

require('styles//ImageCard.scss');
import redirect from '../util/redirect';
import { t } from '../util/i18n';

class ImageCardComponent extends React.Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false,
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onClick = this.onClick.bind(this);
    this.redirect = this.redirect.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  redirect() {
    this.setState({ modalIsOpen: false });
    redirect(this.props.url);
  }

  onClick() {
    if (this.props.thirdparty) this.setState({ modalIsOpen: true });
    else redirect(this.props.url);
  }

  render() {
    return (
      <div
        id={'image-card-' + this.props.id}
        className="imagecard-component"
        onClick={this.onClick}
      >
        <div
          className={`image-icon ${'image-card-' + this.props.id}`}
          style={{ backgroundImage: this.props.imagePath }}
        ></div>
        <div className={`imagecard-content ${'image-card-' + this.props.id}`}>
          <div className={`imagecard-title ${'image-card-' + this.props.id}`}>
            <div className="text1">
              {this.props.text1}
              {this.props.text1_2 && (
                <div>{ this.props.text1_2 }</div>
              )}
            </div>
            <div className="text2">{this.props.text2}</div>
            {this.props.location && (
              <div className="location">
                <img
                  className="location-icon"
                  src="../images/location.png"
                ></img>
                <span className="location-text">
                  {this.props.location}
                  {this.props.location2 && (
                    <div>{ this.props.location2 }</div>
                  )}
                </span>
              </div>
            )}
            {this.props.duration && (
              <div className="location">
                <img
                  className="calendar-icon"
                  src="../images/calendar.png"
                ></img>
                <span className="location-text calendar-text">
                  {this.props.duration}
                </span>
              </div>
            )}
            {this.props.text3 && (
              <div className="location">
                <img className="calendar-icon" src="../images/star.png"></img>
                <span className="location-text calendar-text">
                  {this.props.text3}
                </span>
              </div>
            )}
          </div>
          {this.props.disabled && (
            <div
              id={'image-card-button-' + this.props.id}
              className="imagecard-button disabled"
            >
              {t(this.props.buttonText || 'FULLY BOOKED')}
            </div>
          )}
          {!this.props.disabled && (
            <div
              id={'image-card-button-' + this.props.id}
              className="imagecard-button"
            >
              {t(this.props.buttonText || 'BOOK')}
            </div>
          )}
          
        </div>
        {this.props.cr && (
          <img className="cr-corner" src="../images/cr_corner.png"></img>
        )}
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          shouldFocusAfterRender={false}
          ariaHideApp={false}
        >
          <h2 className="modal-title">TAKING OFF FROM HERE?</h2>
          <p className="modal-text">
            You are now leaving Changi Airport Group's website and about to head
            to a third party site. We have no control over it's content or
            availability and do not assume responsibility for any transactions
            that may occur.
          </p>
          <div className="modal-button" onClick={this.closeModal}>
            NO
          </div>
          <div className="modal-button" onClick={this.redirect}>
            YES{' '}
          </div>
        </Modal>
      </div>
    );
  }
}
ImageCardComponent.displayName = 'ImageCardComponent';

export default ImageCardComponent;



// WEBPACK FOOTER //
// ./src/components/ImageCardComponent.js